export enum AdminTablePaths {
  BRAND = 'brand',
  BRANCH = 'branch',
  REGISTER = 'register',
  LOGIN = 'login',
  PRODUCT = 'product',
  SLIDER = 'slider',
  CATEGORY = 'category',
  ORDER = 'order',
  USER = 'user',
  SETTING = 'setting',
  AUTO_ORDER_STATUS = 'setting/auto-order-status',
  PAYMENT = 'payment',
  CONTACT = 'contact',
  POST = 'post',
  FILES = 'files',
  DAILY_ORDER = 'order/dailyOrder',
  DAILY_PRICE = 'order/dailyPrice',
  NUMBER_OF_PRODUCT_SALES = 'order/numberOfProductSales',
  FORGOT_PASSWORD = 'forgotPassword',
  RESET_PASSWORD = 'resetPassword',
}
